var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34301"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    width: 159,
    height: 159,
    rx: 79.5,
    fill: "#E2E2EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 34272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 37173",
    d: "M100.514 56.9581C100.511 62.5033 98.3137 67.8221 94.4021 71.7527C90.4906 75.6833 85.1827 77.9065 79.6375 77.9367C74.0798 77.9434 68.7464 75.7455 64.807 71.8252C60.8676 67.9049 58.6439 62.5822 58.6235 57.0246C58.6263 51.4664 60.8332 46.1363 64.7605 42.2032C68.6879 38.27 74.0148 36.055 79.573 36.0439C85.1178 36.0576 90.432 38.2648 94.3552 42.1832C98.2783 46.1017 100.494 51.4132 100.514 56.9581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction 2",
    d: "M112.019 122.959H46.9795C46.9628 122.545 46.9628 122.168 46.9628 121.821C46.8827 112.595 50.2865 103.679 56.494 96.8538C59.3804 93.6025 62.9231 90.9999 66.8886 89.2175C70.8542 87.4352 75.1525 86.5137 79.5002 86.5137C83.8478 86.5137 88.1461 87.4352 92.1117 89.2175C96.0772 90.9999 99.62 93.6025 102.506 96.8538C108.714 103.679 112.118 112.595 112.038 121.821C112.038 122.2 112.038 122.58 112.021 122.953L112.019 122.959Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.4a86bceb2324675c255dcba392f9e9e7.svg";
export { ForwardRef as ReactComponent };